import React from "react";
import {
  Button,
  NewTab,
  PageHeader,
  PageTab,
  PageTitle,
} from "../../../components";
import UpcomingPayCycles from "./SalaryProfileView/UpcomingPayCycles";
import PastPayCycles from "./SalaryProfileView/PastPayCycles";
import { useNavigate } from "react-router-dom";

const SalaryProfileView = () => {
  const navigate = useNavigate();
  const SalaryProfileViewMenus = [
    {
      title: "Upcoming Pay Cycles",
      page: <UpcomingPayCycles />,
      type: "main",
    },

    {
      title: "Past Pay Cycles",
      page: <PastPayCycles />,
      type: "main",
    },
  ];
  return (
    <div>
      <PageHeader
        Section={
          <div className="flex my-3">
            <PageTitle title={"W2 Payroll (Monthly)"} tag="h6" />
          </div>
        }
        RightSection={
          <>
            <Button
              title="Back"
              size="sm"
              icon={"arrow_left_alt"}
              onClick={() => navigate("/payroll/salary-profile-configaration")}
            />
          </>
        }
      />
      <div>
        <NewTab
          tabs={SalaryProfileViewMenus}
          color="black"
          variant="outlined"
          tabLevel="employees"
        />
      </div>
    </div>
  );
};

export default SalaryProfileView;
